import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { ArrowLeft as P } from "../node_modules/@phosphor-icons/react/dist/csr/ArrowLeft.es.js";
import { ArrowRight as w } from "../node_modules/@phosphor-icons/react/dist/csr/ArrowRight.es.js";
import { useState as d, useEffect as _ } from "react";
import "../node_modules/react-pdf/dist/esm/index.es.js";
/* empty css                                                       */
/* empty css                                                             */
import p from "./primitives/MButton.es.js";
import j from "../node_modules/react-pdf/dist/esm/Document.es.js";
import E from "../node_modules/react-pdf/dist/esm/Page.es.js";
import { GlobalWorkerOptions as N } from "../node_modules/react-pdf/node_modules/pdfjs-dist/build/pdf.es.js";
N.workerSrc = "//unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs";
const $ = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/"
}, G = ({ src: u, onLoad: f, onError: g, className: l, style: c }) => {
  const [r, b] = d(null), [o, a] = d(1), s = "pdf-viewer-dynamic-styles";
  _(() => {
    if (!c) return;
    const e = document.getElementById(s);
    e && e.remove();
    const i = document.createElement("style");
    return i.id = s, i.textContent = `
      .react-pdf__Document {
        ${Object.entries(c).map(([n, v]) => `${n}: ${v};`).join(`
`)}
      }
    `, document.head.appendChild(i), () => {
      const n = document.getElementById(s);
      n && n.remove();
    };
  }, [c]);
  const h = () => {
    o > 1 && a((e) => e - 1);
  }, x = () => {
    r && o < r && a((e) => e + 1);
  }, y = ({ nPages: e }) => {
    b(e), f();
  }, k = () => {
    g();
  };
  return /* @__PURE__ */ t("div", { className: `${l || ""} rcl--relative`, children: /* @__PURE__ */ m(
    j,
    {
      file: u,
      onLoadSuccess: (e) => {
        y({ nPages: e.numPages });
      },
      onLoadError: k,
      className: l,
      options: $,
      children: [
        r && /* @__PURE__ */ t(E, { pageNumber: o }),
        r && /* @__PURE__ */ m("div", { className: "rcl--sticky rcl--bottom-2 rcl--left-2 rcl--flex rcl--w-[140px] rcl--items-center rcl--justify-center rcl--rounded-md rcl--bg-black rcl--bg-opacity-25 rcl--px-4 rcl--py-1", children: [
          /* @__PURE__ */ t(
            p,
            {
              onClick: h,
              disabled: o === 1,
              size: "auto",
              variant: "ghost",
              children: /* @__PURE__ */ t(P, {})
            }
          ),
          /* @__PURE__ */ t("span", { className: "rcl--mx-2 rcl--select-none rcl--text-sm rcl--text-white", children: `${o} of ${r}` }),
          /* @__PURE__ */ t(
            p,
            {
              onClick: x,
              disabled: o === r,
              size: "auto",
              variant: "ghost",
              children: /* @__PURE__ */ t(w, {})
            }
          )
        ] })
      ]
    }
  ) });
};
export {
  G as default
};
//# sourceMappingURL=PDFViewer.es.js.map
